module.exports = __webpack_public_path__ + "img/vida-verd-04.eebd4a78.jpg";